import { FelaCSS, FelaCSSWithCustomSelectors, colors } from '@bridebook/ui';

interface IStyles {
  wrapper?: FelaCSSWithCustomSelectors;
}

const styles = (isMobile: boolean): IStyles => {
  const disabledInteraction: FelaCSS = {
    cursor: 'default',
    pointerEvents: 'none',
  };

  return {
    wrapper: {
      alignItems: 'flex-start',

      '> .pagination': {
        maxWidth: 350,
        display: 'flex',
        alignItems: 'center',
        listStyleType: 'none',
        overflow: 'hidden',

        '> li': {
          marginLeft: '5px',
          marginHorizontal: 2,

          ':nth-of-type(2)': {
            marginLeft: '0',
          },

          ':first-of-type': {
            display: 'none',

            '> a': {
              ':hover': {
                color: colors.white,
                backgroundColor: colors.space,
              },
            },
          },

          ':last-of-type': {
            display: 'none',

            '> a': {
              ':hover': {
                color: colors.white,
                backgroundColor: colors.space,
              },
            },
          },

          '> a': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '10px',
            paddingBottom: '10px',
            paddingLeft: '15px',
            paddingRight: '15px',
            fontDefault: isMobile ? 8 : 16,
            lineHeight: '20px',
            color: colors.indigoCrush,
            backgroundColor: colors.indigoCrush04,
            borderRadius: '100px',

            ':hover': {
              color: colors.white,
              backgroundColor: colors.space,
              textDecoration: 'none',
            },

            ':focus': {
              textDecoration: 'none',
            },

            ':active': {
              textDecoration: 'none',
            },
          },
        },

        '> li.selected': {
          ...disabledInteraction,

          '> a': {
            color: colors.white,
            backgroundColor: colors.space,
          },
        },

        '> li.break': {
          ...disabledInteraction,
        },
      },
      maxWidthMobile: {
        marginBottom: 16,
      },
    },
  };
};

export default styles;
